<template>
  <footer>
    <div class="row footer-one">
      <div class="col-xs-6 box text-left float-left">
        <h4 class="text-uppercase font-weight-bold color-text font-size-16">Thông tin</h4>
        <p class="mb-0"><a href="/huong-dan" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Giới thiệu</a></p>
        <p class="mb-0"><a href="/huong-dan?tab=dieu-khoan-su-dung" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Điều khoản sử dụng</a></p>
        <p class="mb-0"><a href="/huong-dan?tab=huong-dan-su-dung" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Hướng dẫn sử dụng</a></p>
        <p class="mb-0"><a href="/huong-dan?tab=phuong-thuc-thanh-toan" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Phương thức thanh toán</a></p>
        <p class="mb-0"><a href="/bao-ve-nguoi-tieu-dung" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Chính sách bảo vệ thông tin cá nhân người tiêu dùng</a></p>
        <p class="mb-0"><a href="/dieu-khoan-dich-vu" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Điều khoản dịch vụ</a></p>
        <p class="mb-0"><a href="/phuong-thuc-cung-ung-dich-vu" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Phương thức cung ứng dịch vụ</a></p>
        <p class="mb-0"><a href="/huong-dan?tab=lien-he" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Liên hệ</a></p>
      </div>

      <div class="col-xs-6 box text-left float-left">
        <h4 class="text-uppercase font-weight-bold color-text font-size-16">&nbsp;</h4>
        <p class="mb-0"><a href="/bai-hat" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Bài hát</a></p>
        <p class="mb-0"><a href="/nghe-si" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Nghệ sĩ</a></p>
        <p class="mb-0"><a href="/giai-tri/10317/ctkm" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> CTKM</a></p>
        <p class="mb-0 d-none"><a href="/giai-tri" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Giải trí</a></p>
      </div>

      <!--<div class="col-md-5ths box text-left">
        <h4 class="text-uppercase font-weight-bold color-text font-size-16">&nbsp;</h4>
        <p class="mb-0"><a href="/bxh" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> BXH âm nhạc</a></p>
        <p class="mb-0"><a href="/bai-hat?c=XJFY" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Quà tặng âm nhạc</a></p>
        <p class="mb-0"><a href="/bai-hat?c=CSTY_CSTY" class="color-text font-size-13"><span class="fa fa-angle-double-right"></span> Cửa sổ tình yêu</a></p>
      </div>-->

      <div class="col-md-12 box text-left mt-3">
        <h4 class="text-uppercase font-weight-bold color-text font-size-16">Liên hệ</h4>
        <p class="mb-0 d-inline-block"><a href="https://www.facebook.com/VmgMusicOfficial/" class="font-size-13 bg-facebook p-1 color-white">Fanpage <span class="fa fa-facebook"></span></a></p>
        <p class="mb-0 d-inline-block"><a href="javascript:void(0)" class="color-white font-size-13 bg-orange p-1">Hot line: <span class="font-size-18 font-weight-bold">1082</span></a></p>
      </div>

      <div class="col-md-12 box text-left mt-4">
        <h4 class="text-uppercase font-weight-bold color-text font-size-16">Từ khóa nổi bật</h4>
        <div class="mb-0">
          <h4 class="font-size-13 m-0 d-inline-block"><a class="color-text" href="/bai-hat/33319/cung-dan-vo-doi">Cung đàn vỡ đôi</a></h4>,
          <h4 class="font-size-13 m-0 d-inline-block"><a class="color-text" href="/bai-hat/33276/xuan-ve-tren-rung-nui">Xuân về trên rừng núi</a></h4>,
          <h4 class="font-size-13 m-0 d-inline-block"><a class="color-text" href="/bai-hat/33318/dau-vay-du-roi">Đau vậy đủ rồi</a></h4>,
          <h4 class="font-size-13 m-0 d-inline-block"><a class="color-text" href="/bai-hat/33259/vi-sao-anh-co-giau">Vì sao anh cố giấu</a></h4>,
          <h4 class="font-size-13 m-0 d-inline-block"><a class="color-text" href="/bai-hat/30488/sai-lam-van-la-anh-remix-">Sai lầm vẫn là anh Remix</a></h4>,
          <h4 class="font-size-13 m-0 d-inline-block"><a class="color-text" href="/bai-hat/8960/di-qua-mua-dong">Đi qua mùa đông</a></h4>
        </div>
      </div>
    </div>

    <div class="row footer-two bg-blue">
      <div class="col-md-4 float-left d-none">
        <img class="mobifonelogo pt-2" src="../../static/img/mobifone-logo.png"/>
      </div>

      <div class="col-md-4 float-left">
        <span class="color-white font-size-14 d-none">&copy; 2020 VMGMedia. All rights reserved</span>
        <p class="color-white font-size-14 m-0">Đơn vị sở hữu Website:  Công ty Cổ Phần Truyền thông VMG</p>
        <p class="color-white font-size-14 m-0">Địa chỉ trụ sở chính: Tầng 6, Tòa nhà Peakview Tower, số 36 Hoàng Cầu, Phường Ô Chợ Dừa, Quận Đống Đa, Thành Phố Hà Nội, Việt Nam</p>
        <p class="color-white font-size-14 m-0">Điện thoại:  (+84) 24 35378820 </p>
        <p>
          <a href='http://online.gov.vn/Home/WebDetails/80235'>
            <img width="200" alt='' title='' src='http://online.gov.vn/Content/EndUser/LogoCCDVSaleNoti/logoSaleNoti.png'/>
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "FooterMobile"
  }
</script>

<style scoped>
  footer{
    padding: 1rem 0 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterMobile.vue